import React from 'react'

const Map = () => {
  return (
    <section className='w-screen h-[40rem]'>
      <iframe title='map' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.9815788544925!2d144.94950238961303!3d-37.81390046177629!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d4949e03ba7%3A0x3a4bed3cd2de0c6!2s269%20King%20St%2C%20Melbourne%20VIC%203000%2C%20Australia!5e0!3m2!1spl!2spl!4v1700397644553!5m2!1spl!2spl"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className='w-full h-full'></iframe>
    </section>
  )
}

export default Map
